export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  chapters: number;
  rating: number;
  views: string;
  updatedAt: string;
  tags: string[];
}

export const categories = [
  { name: '韩漫', slug: 'hanman', icon: 'ri-global-line', count: 48 },
  { name: '国漫', slug: 'guoman', icon: 'ri-flag-line', count: 56 },
  { name: '日漫', slug: 'riman', icon: 'ri-sun-line', count: 72 },
  { name: '耽美', slug: 'danmei', icon: 'ri-hearts-line', count: 35 },
  { name: '玄幻', slug: 'xuanhuan', icon: 'ri-magic-line', count: 41 },
  { name: '都市', slug: 'dushi', icon: 'ri-building-line', count: 29 },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 22 },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 33 },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '全知读者视角',
    author: 'sing N song',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20digital%20illustration%20cover%20art%2C%20warm%20golden%20and%20amber%20color%20palette%2C%20soft%20atmospheric%20lighting%2C%20artistic%20character%20portrait%20with%20mysterious%20aura%2C%20dreamy%20ethereal%20mood%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20elegant%20refined%20painterly%20style%2C%20warm%20tones%20with%20golden%20accents%2C%20fantasy%20atmosphere&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '某天，世界变成了他读过的小说。作为唯一知晓结局的读者，金独子必须在这个末日世界中生存下去。他拥有全知视角，知晓每一个角色的命运和每一个隐藏的剧情，但这真的足够吗？当现实与小说的界限逐渐模糊，他发现自己不再只是一个旁观者——他正在改写故事的结局。',
    status: '连载中',
    chapters: 186,
    rating: 9.6,
    views: '3280万',
    updatedAt: '2026-08-03',
    tags: ['奇幻', '冒险', '生存', '系统流'],
  },
  {
    id: 'comic-2',
    title: '我独自升级',
    author: 'Chugong',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20action%20fantasy%20illustration%20cover%20art%2C%20dark%20atmospheric%20with%20warm%20golden%20highlights%2C%20powerful%20character%20silhouette%20with%20glowing%20aura%2C%20intense%20dramatic%20mood%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20refined%20digital%20painting%20style%2C%20deep%20shadows%20with%20warm%20light%20accents%2C%20epic%20fantasy%20atmosphere&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '在一个突然出现"地下城"和"猎人"的世界里，被称为"人类最弱兵器"的E级猎人成振宇，在一次双重地下城事故中濒临死亡，却意外获得了"系统"的能力。从此，他成为了唯一能够无限升级的猎人，踏上了从最弱到最强的逆袭之路。',
    status: '已完结',
    chapters: 200,
    rating: 9.8,
    views: '5620万',
    updatedAt: '2026-07-28',
    tags: ['热血', '战斗', '升级', '逆袭'],
  },
  {
    id: 'comic-3',
    title: '伯爵家的废物',
    author: 'Yoo Ryeo Han',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20aristocratic%20fantasy%20illustration%20cover%20art%2C%20elegant%20warm%20caramel%20and%20cream%20color%20palette%2C%20refined%20noble%20character%20portrait%2C%20soft%20romantic%20lighting%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20graceful%20painterly%20style%2C%20warm%20golden%20hour%20atmosphere%2C%20aristocratic%20fantasy%20mood&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '金洛克曼是伯爵家的废物长子，被人嘲笑、被家族抛弃。在绝望之际，他意外觉醒了前世的记忆——他曾经是统治大陆的最强魔法师。重获力量的他，将用实力让所有嘲笑过他的人闭嘴，在这片大陆上重新书写属于自己的传奇。',
    status: '连载中',
    chapters: 142,
    rating: 9.4,
    views: '2150万',
    updatedAt: '2026-08-02',
    tags: ['奇幻', '转生', '魔法', '逆袭'],
  },
  {
    id: 'comic-4',
    title: '某天成为公主',
    author: 'Plutus',
    category: '韩漫',
    categorySlug: 'hanman',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romantic%20fantasy%20princess%20illustration%20cover%20art%2C%20soft%20warm%20peach%20and%20cream%20color%20palette%2C%20elegant%20female%20character%20portrait%20with%20flowing%20dress%2C%20dreamy%20romantic%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20delicate%20painterly%20style%2C%20soft%20golden%20lighting%2C%20fairy%20tale%20fantasy%20mood&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '一觉醒来，我变成了小说里的公主——而且是一个注定要被自己亲生父亲处死的悲剧公主。为了活下去，我决定用自己的可爱攻势融化那个冷酷无情的皇帝父亲的心。然而，事情的发展似乎逐渐偏离了原作的轨道……',
    status: '连载中',
    chapters: 160,
    rating: 9.5,
    views: '2890万',
    updatedAt: '2026-08-01',
    tags: ['恋爱', '宫廷', '转生', '温馨'],
  },
  {
    id: 'comic-5',
    title: '斗罗大陆',
    author: '唐家三少',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20martial%20arts%20fantasy%20illustration%20cover%20art%2C%20warm%20amber%20and%20gold%20color%20palette%2C%20heroic%20character%20with%20martial%20spirit%20aura%2C%20epic%20dramatic%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20refined%20digital%20painting%20style%2C%20mystical%20golden%20energy%20glow%2C%20oriental%20fantasy%20mood&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '唐门外门弟子唐三，因偷学内门绝学被追杀，跳崖明志后穿越到斗罗大陆。在这个武魂觉醒的世界里，他凭借前世记忆和双生武魂的天赋，一步步走向巅峰。从圣魂村到史莱克学院，从魂师大赛到海神岛试炼，唐三的传奇故事正在上演。',
    status: '连载中',
    chapters: 350,
    rating: 9.3,
    views: '8920万',
    updatedAt: '2026-08-03',
    tags: ['玄幻', '热血', '武魂', '战斗'],
  },
  {
    id: 'comic-6',
    title: '全职高手',
    author: '蝴蝶蓝',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20esports%20gaming%20illustration%20cover%20art%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20cool%20gamer%20character%20portrait%20with%20focused%20expression%2C%20modern%20competitive%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20clean%20digital%20painting%20style%2C%20warm%20ambient%20lighting%2C%20esports%20fantasy%20mood&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '荣耀职业联赛历史上最伟大的选手叶修，被俱乐部驱逐后，在网吧里重新开始。带着十年荣耀经验和一把自制武器"千机伞"，他组建全新的草根战队，从挑战赛一路杀回职业联盟，用实力证明——荣耀，从来不会辜负真正热爱它的人。',
    status: '已完结',
    chapters: 280,
    rating: 9.7,
    views: '6720万',
    updatedAt: '2026-06-15',
    tags: ['电竞', '热血', '逆袭', '竞技'],
  },
  {
    id: 'comic-7',
    title: '一人之下',
    author: '米二',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20supernatural%20modern%20fantasy%20illustration%20cover%20art%2C%20warm%20earthy%20amber%20tones%2C%20mysterious%20character%20with%20supernatural%20aura%2C%20urban%20fantasy%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20dynamic%20digital%20painting%20style%2C%20warm%20dramatic%20lighting%2C%20supernatural%20thriller%20mood&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '普通大学生张楚岚，因为爷爷的坟墓被盗而卷入了异人世界的纷争。在这个隐藏在普通社会之下的异能者世界里，他遇见了神秘的不老少女冯宝宝，开始揭开自己身世之谜和甲申之乱的真相。一场跨越数十年的秘密正在浮出水面。',
    status: '连载中',
    chapters: 420,
    rating: 9.5,
    views: '7350万',
    updatedAt: '2026-08-02',
    tags: ['异能', '都市', '悬疑', '热血'],
  },
  {
    id: 'comic-8',
    title: '狐妖小红娘',
    author: '小新',
    category: '国漫',
    categorySlug: 'guoman',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20romantic%20fantasy%20fox%20spirit%20illustration%20cover%20art%2C%20warm%20peach%20and%20coral%20color%20palette%2C%20beautiful%20female%20fox%20spirit%20character%20with%20floral%20elements%2C%20dreamy%20romantic%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20delicate%20painterly%20style%2C%20soft%20warm%20glowing%20lighting%2C%20oriental%20romantic%20fantasy%20mood&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '在一个人与妖共存的世界里，狐妖小红娘涂山苏苏的职责是为前世的爱人牵线续缘。每一个故事都是一段跨越生死的爱恋，每一个委托都承载着无法放下的执念。以红线为引，以记忆为桥，她用最温柔的方式守护着世间最珍贵的情感。',
    status: '连载中',
    chapters: 310,
    rating: 9.4,
    views: '4580万',
    updatedAt: '2026-07-30',
    tags: ['恋爱', '奇幻', '古风', '治愈'],
  },
  {
    id: 'comic-9',
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20dark%20fantasy%20samurai%20illustration%20cover%20art%2C%20dramatic%20warm%20amber%20and%20crimson%20tones%2C%20intense%20warrior%20character%20with%20blade%2C%20dark%20atmospheric%20with%20fiery%20accents%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20bold%20dynamic%20digital%20painting%20style%2C%20dramatic%20lighting%20with%20warm%20fire%20glow%2C%20epic%20dark%20fantasy%20mood&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '大正时代，少年灶门炭治郎一家惨遭鬼的屠杀，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复人形的方法，炭治郎加入了鬼杀队，踏上了斩鬼之旅。在血与火的试炼中，他不断成长，与伙伴们一起对抗鬼的始祖——鬼舞辻无惨。',
    status: '已完结',
    chapters: 205,
    rating: 9.7,
    views: '10250万',
    updatedAt: '2026-05-20',
    tags: ['热血', '战斗', '奇幻', '兄妹情'],
  },
  {
    id: 'comic-10',
    title: '咒术回战',
    author: '芥见下下',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20supernatural%20action%20illustration%20cover%20art%2C%20warm%20amber%20and%20charcoal%20tones%2C%20powerful%20sorcerer%20character%20with%20cursed%20energy%20aura%2C%20intense%20dark%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20striking%20digital%20painting%20style%2C%20dramatic%20warm%20lighting%20contrast%2C%20supernatural%20battle%20mood&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '高中生虎杖悠仁在偶然吃下诅咒之王两面宿傩的手指后，成为了宿傩的容器。为了收集散落各地的宿傩手指并消灭诅咒，他加入了东京都立咒术高等专门学校，与伙伴们一起对抗不断出现的强大咒灵，在这个充满诅咒的世界中守护重要的人。',
    status: '连载中',
    chapters: 260,
    rating: 9.5,
    views: '8120万',
    updatedAt: '2026-08-03',
    tags: ['热血', '战斗', '咒术', '校园'],
  },
  {
    id: 'comic-11',
    title: '间谍过家家',
    author: '远藤达哉',
    category: '日漫',
    categorySlug: 'riman',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20comedy%20spy%20family%20illustration%20cover%20art%2C%20warm%20cream%20and%20caramel%20color%20palette%2C%20elegant%20spy%20family%20trio%20portrait%2C%20lighthearted%20warm%20atmosphere%2C%20manga%20cover%20aesthetic%2C%20no%20text%2C%20clean%20charming%20digital%20painting%20style%2C%20soft%20warm%20domestic%20lighting%2C%20cozy%20comedic%20mood&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '为了执行秘密任务"枭"，西国最强间谍"黄昏"需要组建一个临时家庭。他收养了能读心的超能力少女阿尼亚，与身份成谜的杀手约尔假结婚。三个人各怀秘密，却在这个虚假的家庭中找到了真正的温暖。一场间谍、杀手与超能力者组成的奇妙家庭喜剧就此展开。',
    status: '连载中',
    chapters: 98,
    rating: 9.6,
    views: '5680万',
    updatedAt: '2026-08-01',
    tags: ['搞笑', '温馨', '间谍', '家庭'],
  },
  {
    id: 'comic-12',
    title: '魔道祖师',
    author: '墨香铜臭',
    category: '耽美',
    categorySlug: 'danmei',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20style%20xianxia%20fantasy%20illustration%20cover%20art%2C%20warm%20coral%20and%20amber%20tones%2C%20elegant%20male%20cultivator%20character%20with%20flowing%20robes%2C%20romantic%20atmospheric%20mood%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20refined%20painterly%20style%2C%20soft%20golden%20ethereal%20lighting%2C%20oriental%20cultivation%20fantasy%20mood&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '十三年前，夷陵老祖魏无羡因修炼鬼道被仙门百家围剿而死。十三年后，他被人用禁术献舍重生，与旧识蓝忘机重逢。在调查一宗宗诡异事件的过程中，两人逐渐揭开了当年的真相，也重新审视了彼此之间纠缠两世的情谊。',
    status: '已完结',
    chapters: 120,
    rating: 9.8,
    views: '12500万',
    updatedAt: '2026-04-10',
    tags: ['古风', '修仙', '悬疑', '情感'],
  },
  {
    id: 'comic-13',
    title: '天官赐福',
    author: '墨香铜臭',
    category: '耽美',
    categorySlug: 'danmei',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20style%20heavenly%20fantasy%20illustration%20cover%20art%2C%20warm%20peach%20and%20cream%20tones%2C%20graceful%20celestial%20character%20with%20divine%20aura%2C%20ethereal%20romantic%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20luminous%20painterly%20style%2C%20soft%20divine%20golden%20lighting%2C%20heavenly%20fantasy%20mood&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '八百年前，谢怜是风光无限的仙乐太子。八百年后，他第三次飞升，却成了三界笑柄。在凡间历劫时，他遇见了一个神秘的红衣少年花城。这个看似普通的少年，却似乎与他有着跨越八百年的羁绊。一个关于信仰、守护与不灭之爱的故事，正在三界之间缓缓展开。',
    status: '已完结',
    chapters: 145,
    rating: 9.9,
    views: '9860万',
    updatedAt: '2026-03-25',
    tags: ['古风', '修仙', '神话', '深情'],
  },
  {
    id: 'comic-14',
    title: '完美世界',
    author: '辰东',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xuanhuan%20fantasy%20illustration%20cover%20art%2C%20warm%20amber%20and%20gold%20tones%2C%20powerful%20young%20cultivator%20with%20mystical%20beast%20companion%2C%20epic%20fantasy%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20grand%20digital%20painting%20style%2C%20warm%20golden%20divine%20lighting%2C%20oriental%20epic%20fantasy%20mood&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。石昊出生在下界荒域的石村，天生至尊骨被夺，却凭借不屈的意志和逆天的天赋，一步步走出大荒，登上九天十地之巅。在这个万族争锋的完美世界里，他以一己之力，谱写了一段不朽的至尊传奇。',
    status: '连载中',
    chapters: 520,
    rating: 9.2,
    views: '6870万',
    updatedAt: '2026-08-02',
    tags: ['玄幻', '修仙', '热血', '战斗'],
  },
  {
    id: 'comic-15',
    title: '遮天',
    author: '辰东',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xuanhuan%20cosmic%20fantasy%20illustration%20cover%20art%2C%20warm%20deep%20amber%20and%20bronze%20tones%2C%20lone%20cultivator%20against%20cosmic%20backdrop%2C%20vast%20epic%20atmosphere%2C%20Chinese%20comic%20cover%20aesthetic%2C%20no%20text%2C%20atmospheric%20digital%20painting%20style%2C%20warm%20cosmic%20golden%20lighting%2C%20grand%20celestial%20fantasy%20mood&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '冰冷与黑暗并存的宇宙深处，九具庞大的龙尸拉着一口青铜古棺，亘古长存。叶凡与同学们在泰山之巅被九龙拉棺带入星空深处，来到了一个光怪陆离的修真世界。在这里，他要寻找回家的路，也要在这条充满荆棘的修炼之路上，证得自己的大道。',
    status: '连载中',
    chapters: 480,
    rating: 9.3,
    views: '5960万',
    updatedAt: '2026-08-01',
    tags: ['玄幻', '修仙', '宇宙', '冒险'],
  },
];

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getFeaturedComics(): Comic[] {
  return comics.slice(0, 8);
}

export function getLatestComics(): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
}

export function getPopularComics(): Comic[] {
  return [...comics].sort((a, b) => b.rating - a.rating);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug)
    .slice(0, limit);
}